<script>
export default {
    props: {
        copyTarget: {
            // This is the id or class of the element to be copied
            type: String,
            required: true
        },
        targetProp: {
            // This is the element property to copy the value from
            type: String,
            default: 'innerText'
        }
    },
    emits: ['copied'],
    data() {
        return {
            copied: false
        }
    },
    methods: {
        copy() {
            const target = document.querySelector(this.copyTarget)
            const prop = target[this.targetProp]

            navigator.clipboard.writeText(prop).then(() => {
                this.copied = true
                this.$emit('copied')
            })

            setTimeout(() => {
                this.copied = false
            }, 5000)
        }
    },
    render() {
        return this.$slots.default({
            copyTarget: this.copyTarget,
            targetProp: this.targetProp,
            copied: this.copied,
            copy: this.copy
        })
    }
}
</script>
